import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Import des images
import image1 from "../assets/1.jpeg";
import image2 from "../assets/hands.jpg";
import image3 from "../assets/man.jpg";
import image4 from "../assets/wman.jpg";

const TopBar = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ bgcolor: "green" }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            LaafiSeebre
          </Typography>
          <Button color="inherit" component={Link} to="/login">
            Connexion
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      image: image1,
      alt: "Santé et assurance",
    },
    {
      image: image2,
      alt: "Services médicaux",
    },
    {
      image: image3,
      alt: "Professionnels de santé",
    },
    {
      image: image4,
      alt: "Personnel médical",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === slides.length - 1 ? 0 : prevSlide + 1
      );
    }, 5000); // Change d'image toutes les 5 secondes

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div>
      <TopBar />
      <div style={{ fontFamily: "Arial, sans-serif" }}>
        {/* Section Hero avec Carousel */}
        <section
          style={{
            position: "relative",
            height: "500px",
            overflow: "hidden",
          }}
        >
          {/* Carousel d'images en arrière-plan */}
          <div style={{ position: "absolute", width: "100%", height: "100%" }}>
            {slides.map((slide, index) => (
              <div
                key={index}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  opacity: currentSlide === index ? 1 : 0,
                  transition: "opacity 1s ease-in-out",
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  filter: "brightness(0.7)",
                }}
                aria-hidden={currentSlide !== index}
              />
            ))}
          </div>

          {/* Contenu superposé sur le carousel */}
          <div
            style={{
              position: "relative",
              textAlign: "center",
              padding: "100px 20px",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 2,
            }}
          >
            <h1
              style={{
                fontSize: "3rem",
                color: "#ffffff",
                textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
              }}
            >
              Bienvenue sur LaafiSeebre
            </h1>
            <p
              style={{
                fontSize: "1.4rem",
                color: "#ffffff",
                maxWidth: "800px",
                margin: "20px auto",
                textShadow: "1px 1px 3px rgba(0,0,0,0.7)",
              }}
            >
              Simplification de la gestion des soins de santé pour les
              assureurs, hôpitaux, pharmacies et laboratoires.
            </p>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/login"
              style={{
                marginTop: "30px",
                backgroundColor: "#2e7d32",
                padding: "10px 30px",
                fontSize: "1.1rem",
              }}
            >
              Commencer
            </Button>
          </div>

          {/* Indicateurs du carousel */}
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              zIndex: 3,
            }}
          >
            {slides.map((_, index) => (
              <button
                key={index}
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background:
                    currentSlide === index
                      ? "#ffffff"
                      : "rgba(255,255,255,0.5)",
                  margin: "0 5px",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={() => setCurrentSlide(index)}
                aria-label={`Slide ${index + 1}`}
              />
            ))}
          </div>
        </section>

        {/* Section Pourquoi LaafiSeebre */}
        <section
          style={{
            padding: "70px 20px",
            backgroundColor: "#ffffff",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "2.2rem",
              color: "#2e7d32",
              marginBottom: "30px",
            }}
          >
            Pourquoi LaafiSeebre ?
          </h2>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              flexWrap: "wrap",
              maxWidth: "1200px",
              margin: "0 auto",
            }}
          >
            <div
              style={{
                maxWidth: "330px",
                margin: "20px",
                padding: "15px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "8px",
              }}
            >
              <h3
                style={{
                  color: "#2e7d32",
                  fontSize: "1.5rem",
                  marginBottom: "15px",
                }}
              >
                Pour les Assureurs
              </h3>
              <p style={{ color: "#555", lineHeight: "1.6" }}>
                Gérez efficacement vos clients assurés et simplifiez le
                traitement des réclamations avec notre plateforme intuitive.
              </p>
            </div>
            <div
              style={{
                maxWidth: "330px",
                margin: "20px",
                padding: "15px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "8px",
              }}
            >
              <h3
                style={{
                  color: "#2e7d32",
                  fontSize: "1.5rem",
                  marginBottom: "15px",
                }}
              >
                Pour les Hôpitaux et Cliniques
              </h3>
              <p style={{ color: "#555", lineHeight: "1.6" }}>
                Servez les patients assurés de manière fluide avec notre système
                de vérification en temps réel et de facturation automatisée.
              </p>
            </div>
            <div
              style={{
                maxWidth: "330px",
                margin: "20px",
                padding: "15px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "8px",
              }}
            >
              <h3
                style={{
                  color: "#2e7d32",
                  fontSize: "1.5rem",
                  marginBottom: "15px",
                }}
              >
                Pour les Pharmacies et Laboratoires
              </h3>
              <p style={{ color: "#555", lineHeight: "1.6" }}>
                Fournissez aux patients assurés des médicaments et des tests
                tout en garantissant une facturation précise et sans erreur.
              </p>
            </div>
          </div>
        </section>

        {/* Pied de page */}
        <footer
          style={{
            backgroundColor: "#2e7d32",
            color: "#fff",
            textAlign: "center",
            padding: "25px",
            marginTop: "30px",
          }}
        >
          <p>
            &copy; {new Date().getFullYear()} LaafiSeebre. Tous droits réservés.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Home;
